<template>
    <div>
      <div class="scroll-container">
        <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :columns="columns"
                :data-source="data"
                :loading="loading"
                rowKey="id"
                :pagination="pagination"
        >
         <span slot="status" slot-scope="text, record">
         <a-switch @click="onChange(record)" :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
         <span slot="action" slot-scope="text, record"><i v-if="$_hasAll(['btn_manage_language'])" style="color:#838383">暂无操作权限</i>
           <a @click="goToManageLanguagePack(text.id ,text.name)" v-has="'btn_manage_language'">管理语言包<a-divider type="vertical"/></a>
           <a  @click="(record)=>{visibleForm = true; titleForm='编辑',editId=text.id;}">编辑</a>
         </span>
        </a-table>
      </div>
        <LanguageListForm :visible="visibleForm" :title="titleForm"  :editId="editId"
                    @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList(this.pageNum)}"></LanguageListForm>
    </div>
</template>

<script>
    import LanguageListForm from "./languageListForm";
    import API from "../api";
    import {changStatus, removeById,orderList} from "../../../../utils/utils"
    const columns =  [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: "8%",
        },
        {
            title: "中文名称",
            dataIndex: "name",
            ellipsis: true,
            key: "name",
        },
        {
            title: "英文名称",
            key: "name_en",
            ellipsis: true,
            dataIndex: "name_en",
        },
        {
            title: "本语种名称",
            key: "name_lang",
            ellipsis: true,
            dataIndex: "name_lang",
        },
        {
            title: "语种简写",
            key: "google_code",
            ellipsis: true,
            dataIndex: "google_code",
        },
        {
            title: "html语种简写",
            key: "html_code",
            ellipsis: true,
            dataIndex: "html_code",
        },
        {
            title: "状态",
            key: "status",
            width: "150px",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "languageList",
        data(){
            return{
                pageNum:"",
                current:1,
                visibleForm: false,
                titleForm: "",
                editId: "1",
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data:[],
                columns,
                selectedRowKeys: [],
                loading: true,
                sortLists:[]
            }
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        mounted(){
            this.getList()
        },
        components:{LanguageListForm},
        methods: {
            goToManageLanguagePack(id,name){
                this.$router.push({path: '/UserBackground/ManageLanguagePack', query: {id: id, name:name}})
            },
            getList(page) {
                this.pageNum=page
                API.language.GET_LIST(page||1).then(res => {
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },
            getchangId(data) {
                this.sortLists=[]
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < data.length; i++) {
                    sortListOrder.id = data[i].id
                    sortListOrder.list_order = data[i].list_order
                    this.sortLists.push(sortListOrder)
                    sortListOrder = {}
                    if (data[i].children && data[i].children.length > 0) {
                        this.getchangId(data[i].children)
                    }
                }
            },

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                orderList(API.language.LIST_ORDER,[Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            start() {
                    removeById(API.language.DELE,this.selectedRowKeys).then(res => {
                        if (res == true) {
                            this.getList()
                            this.selectedRowKeys = [];
                        }
                    })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
    }
</script>

<style scoped>
    .inputs {display: inline-block;width: 70px}
    .scroll-container{height: calc(100vh - 250px);overflow: auto}
    .scroll-container::-webkit-scrollbar { width: 8px; background: white;}
    .scroll-container::-webkit-scrollbar-corner, .scroll-container::-webkit-scrollbar-thumb, .scroll-container::-webkit-scrollbar-track { border-radius: 4px; }
    .scroll-container::-webkit-scrollbar-corner,.scroll-container::-webkit-scrollbar-track {  background-color: #ddd; box-shadow: inset 0 0 1px #ddd; }
    .scroll-container::-webkit-scrollbar-thumb {background-color: #c1c1c1;}
</style>
